// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"121":"vendor","524":"app"}[chunkId] + "." + {"121":"df8812ba0669e652da86","524":"cbac7881bb58278d75e7"}[chunkId] + ".css";
};